export default "__VITE_ASSET__ch6N5Kqm__"